module.exports = __webpack_public_path__ + "static/img/card1.916b48bf.png";